import ENDPOINTS from "../ApiManager/CadenaEndPoints";
import environment from "../environments/environment";

const BASE_URL = environment.api_url;

class CadenaService {
	
	static getCadenas = () => {
		const url = BASE_URL + ENDPOINTS.GET_CADENAS();
		return fetch(url, {
			method: 'GET',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
          		'Content-Type': 'application/json',
			}
		});
	};
	
	static getCadenasByParams = (nombre, activo) => {
		const url = BASE_URL + ENDPOINTS.GET_CADENAS_BY_PARAMS(nombre, activo);
		return fetch(url, {
			method: 'GET',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
          		'Content-Type': 'application/json',
			}
		});
	}
	
	static crearCadena = (cadena) => {
		const url = BASE_URL + ENDPOINTS.POST_CADENA();
		
		return fetch(url, {
			method: 'POST',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				nombre: cadena.nombre,
				activo: cadena.activo
			})
		});
	}
	
	static actualizarCadena = (cadena) => {
		const url = BASE_URL + ENDPOINTS.ACTUALIZAR_CADENA(cadena.id);
		
		return fetch(url, {
			method: 'PUT',
			headers: {
				'Authorization': '',
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				nombre: cadena.nombre,
				activo: cadena.activo
			})
		});	
	}
	
	}

export default CadenaService;